import React, { useState, useEffect, useContext, useRef } from "react";
import Card from "../../components/ConfigurationCards";
import CreateUserContainer from "../CreateUserContainer/CreateUserContainer";
import {
  CardsWrapperUsers,
  ContentTable,
  Convention,
  ActionDownLoadBulkError,
  ContentLoaderBulk,
  LoadingFile,
  ContentDownloadFile,
  TextDownloadFile,
  CardsWrapper,
  useStyles,
} from "./AdminUsersContainer.styled";
import MaterialTable from "material-table";
import {
  ALL_USERS_ADMINISTRATION,
  BULK_HISTORY_LIST,
  BULK_HISTORY_LIST_AFTER,
  BULK_HISTORY_LIST_BEFORE,
} from "../../GraphQL/Queries";
import { UPDATE_QRUSER, UPDATE_USER_STATUS } from "../../GraphQL/Mutations";
import { useMutation, useLazyQuery } from "@apollo/client";
import { withStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TablePagination from "@material-ui/core/TablePagination";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { DeleteTwoTone, EditTwoTone } from "@material-ui/icons";
import { theme as themeConfig } from "../../themes/themes";
import { getStateLogin, getStateLoginComplete } from "../LayoutHome/stateLogin";
import { ContextBulkUpload } from "../../Store/StoreBulkUpload";
import download from "../../assets/download.png";
import PointersLine from "../../components/Loaders/PointersLine/PointersLine";
import { NotificationManager } from "react-notifications";
import DoneIcon from "@material-ui/icons/Done";
import CircularIndeterminate from "../../components/Loaders/CircularIndeterminate";
import ModalConfirmAction from "../../components/ModalConfirmAction/ModalConfirmAction";
import { uploadExcelFile } from "../../services/ExcelFileManager";
import { getBulkUploadResultLogTxtFile } from "../../services/TxtFileManager";
import { ReactComponent as ExcelIcon } from "../../themes/Icons/Excel_Icon.svg";
import { AntSwitch } from "../../helpers/antSwitch";
import SearchComponent from "../../components/SearchComponent/SearchComponent";
import { ROLES_LABEL } from "../../util/RolesConstants";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: themeConfig.neutral.gray[2500],
    color: "white",
    padding: "1em 1em 1em 0",
    border: "1px solid #dadde9",
  },
}))(Tooltip);

const AdminUsersContainer = ({
  selectedMenu,
  showDownloadPage,
  setUsersListRendered,
}) => {
  const [user] = useState(getStateLoginComplete());
  const [columnUsers, setColumnUsers] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [allPages, setAllPages] = useState(null);
  const [startCursor, setStartCursor] = useState("");
  const [endCursor, setEndCursor] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rowsPerPageOptions] = useState([5, 10, 25]);

  const [runQueryUsersList, { loading: loadingUsers }] = useLazyQuery(
    ALL_USERS_ADMINISTRATION,
    {
      context: { clientName: "LinkUsers" },
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        setAllPages(data.userAdminList?.totalCount);
        if (data.userAdminList.pageInfo.hasNextPage === true) {
          setEndCursor(data.userAdminList.pageInfo.endCursor);
        }
        if (data.userAdminList.pageInfo.hasPreviousPage === true) {
          setStartCursor(data.userAdminList.pageInfo.startCursor);
        }
        setUsersList(
          data.userAdminList?.nodes
            ? data.userAdminList.nodes.map((item) => ({
              ...item,
              cityName: item?.location?.cityName,
              clientName: item?.location?.clientName,
              countryName: item?.location?.countryName,
              emailAddress: item?.userTpId,
              firstName: item?.userFirstName,
              lastName: item?.userLastName,
              ccmsuser: item?.userCcms,
              lobCount: item?.lobs?.length,
              roleId: item?.role?.roleId,
              roleName: ROLES_LABEL[item?.role?.roleId],
              statusId: item?.enabled,
              totpStatus: item?.totpStatus,
              comonocomo:
                item?.isCoMoUser === true
                  ? "Como"
                  : item?.isCoMoUser === false
                    ? "Non Como"
                    : "---",
              supervisor:
                item.supervisorInfo && item.supervisorInfo?.userFullName
                  ? item.supervisorInfo.userFullName
                  : "---",
            }))
            : []
        );
        setUsersListRendered(true);
      },
    }
  );
  const [stateBulkUploadReducer, dispatch] = useContext(ContextBulkUpload);
  const [updateUser] = useMutation(UPDATE_USER_STATUS);
  const [updateShowQrUser] = useMutation(UPDATE_QRUSER);
  const [openDeleteModal, setOpenDeleteModal] = useState(null);
  const [openQrModal, setopenQrModal] = useState(null);
  const classes = useStyles();
  const [formTrigger, setFormTrigger] = useState("");
  const [UsersList, setUsersList] = useState([]);
  const [EditUser, setEditUser] = useState();
  const [renderAgain, setrenderAgain] = useState(false);
  const [searchText, setSearchText] = useState("");
  const rSearch = useRef();

  useEffect(() => {
    if (openQrModal === null) {
      runQueryUsersList({
        variables: { searchBy: searchText, first: rowsPerPage },
      });
    }
  }, [formTrigger, openQrModal, rowsPerPage, searchText]);

  const getDataBySearch = () => {
    setSearchText(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(() => {
        getDataBySearch();
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  function handleChangePageUsers(event, newPage) {
    if (newPage > page) {
      runQueryUsersList({
        variables: {
          first: rowsPerPage,
          after: endCursor,
          searchBy: searchText ? searchText : "",
        },
      });
    } else if (newPage < page) {
      runQueryUsersList({
        variables: {
          last: rowsPerPage,
          before: startCursor,
          searchBy: searchText ? searchText : "",
        },
      });
    }
    setPage(newPage);
  }

  const handleChangeRowsPerPageUsers = (event) => {
    setRowsPerPage(event.target.value ? parseInt(event.target.value) : 5);
    setPage(0);
    runQueryUsersList({
      variables: {
        first: event.target.value ? parseInt(event.target.value) : 5,
        searchBy: searchText ? searchText : "",
      },
    });
  };

  const [runBulkList, { loading: loadingBulkHistory }] = useLazyQuery(
    BULK_HISTORY_LIST,
    {
      context: { clientName: "LinkUsers" },
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        asignData(data);
      },
    }
  );

  const [runBulkListAfter, { loading: loadingBulkHistoryAfter }] = useLazyQuery(
    BULK_HISTORY_LIST_AFTER,
    {
      context: { clientName: "LinkUsers" },
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        asignData(data);
      },
    }
  );

  const [runBulkListBefore, { loading: loadingBulkHistoryBefore }] =
    useLazyQuery(BULK_HISTORY_LIST_BEFORE, {
      context: { clientName: "LinkUsers" },
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        asignData(data);
      },
    });

  const handleEditUser = (rowData) => {
    setEditUser(rowData);
    setFormTrigger("edit");
  };

  let updateUserOld = (rowData) => {
    updateUser({
      variables: {
        userEmailAddress: rowData.emailAddress,
        newStatusId: "DELETED",
      },
      context: { clientName: "LinkUsers" },
    })
      .then((res) => {
        if (res?.data?.changeStatusUser?.userId) {
          NotificationManager.success("User deleted Successfully!!", "", 5000);
          UsersList.splice(
            UsersList.findIndex((f) => f.userId === rowData.userId),
            1
          );
          setUsersList([...UsersList]);
          setOpenDeleteModal(null);
        } else {
          NotificationManager.error("Error to delete user", "", 5000);
          setOpenDeleteModal(null);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let toggleChecked = (rowData) => {
    let newStatusId = rowData.statusId ? "DISABLED" : "ENABLED";
    updateUser({
      variables: {
        userEmailAddress: rowData.emailAddress,
        newStatusId,
      },
      context: { clientName: "LinkUsers" },
    })
      .then((res) => {
        if (res?.data?.changeStatusUser?.userId) {
          rowData.statusId = rowData.statusId ? false : true;
          NotificationManager.success(
            "User status is updated successfully",
            "",
            5000
          );
          setrenderAgain(!renderAgain);
        } else {
          NotificationManager.error("Error to change user status", "", 5000);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const updateUserQR = (rowData) => {
    updateShowQrUser({
      variables: {
        userId: rowData.userId,
        lastUpdateUser: getStateLogin(),
        roleId: parseInt(rowData.roleId),
      },
      context: { clientName: "LinkUsers" },
    }).then((value) => {
      if (
        typeof value.data.updateShowQRUser === "object" ||
        value.data.updateShowQRUser === -1
      ) {
        NotificationManager.error("Error Enable QR Code", "", 5000);
        setopenQrModal(null);
      } else {
        setopenQrModal(null);

        NotificationManager.success("Enable QR Code", "", 5000);
      }
    });
  };

  const bulkUploadUsers = async (data) => {
    uploadExcelFile(data);
  };

  useEffect(() => {
    if (stateBulkUploadReducer.messageBulk.success) {
      runQueryUsersList({
        variables: { searchBy: searchText, first: rowsPerPage },
      });
      dispatch({ type: "loaded" });
    }
  }, [rowsPerPage, searchText, stateBulkUploadReducer]);

  useEffect(() => {
    setFormTrigger("");
  }, [selectedMenu]);

  useEffect(() => {
    if (selectedMenu[0] === "history") {
      runBulkList({
        variables: {
          first: rowsPerPage,
        },
      });
    }
  }, [selectedMenu, rowsPerPage]);

  const asignData = (data) => {
    setAllPages(data?.userBulkUploadAdminList?.totalCount);
    if (data?.userBulkUploadAdminList?.pageInfo?.hasNextPage === true) {
      setEndCursor(data?.userBulkUploadAdminList?.pageInfo?.endCursor);
    }
    if (data?.userBulkUploadAdminList?.pageInfo?.hasPreviousPage === true) {
      setStartCursor(data?.userBulkUploadAdminList?.pageInfo?.startCursor);
    }
    const userBulkUploadAdminList = data.userBulkUploadAdminList.nodes.map(
      (element) => {
        return {
          id: element.userBulkUploadId,
          totalCreated: element.totalCreated,
          totalUpdated: element.totalUpdated,
          totalDeleted: element.totalDeleted,
          totalFailed: element.totalFailed,
          createUser: element.createUser,
          createDate: element.createDate,
          uploadStatusId: element.uploadStatusId,
          elapsedTime: element.elapsedTime,
        };
      }
    );
    setDataList(userBulkUploadAdminList);
  };

  const handleChangePage = (event, newPage) => {
    if (newPage > page) {
      runBulkListAfter({
        variables: {
          first: rowsPerPage,
          after: endCursor,
        },
      });
    }
    if (newPage < page) {
      runBulkListBefore({
        variables: {
          last: rowsPerPage,
          before: startCursor,
        },
      });
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    let newRowsPerPage = event?.target?.value
      ? parseInt(event.target.value)
      : 5;
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const showDeleteModal = () => {
    return openDeleteModal ? (
      <ModalConfirmAction
        title={"Are you sure you want to delete this user?"}
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        fn={updateUserOld}
      />
    ) : null;
  };

  const showQrModal = () => {
    return openQrModal ? (
      <ModalConfirmAction
        title={
          "This action will reset the QR code scanning for this user" +
          "'" +
          "s two-factor authentication. Do you want to proceed?"
        }
        open={openQrModal}
        setOpen={setopenQrModal}
        fn={updateUserQR}
      />
    ) : null;
  };

  useEffect(() => {
    setColumnUsers([
      {
        title: "Name",
        field: "firstName",
        type: "string",
      },
      {
        title: "Last Name",
        field: "lastName",
        type: "string",
        headerStyle: {
          padding: "0px 16px",
        },
      },
      {
        title: "TP ID",
        field: "emailAddress",
        type: "string",
        headerStyle: {
          padding: "0px 16px",
        },
      },
      {
        title: "User Name",
        field: "ccmsuser",
        type: "string",
        headerStyle: {
          padding: "0px 16px",
        },
      },
      {
        title: "Role",
        field: "roleName",
        type: "string",
      },
      {
        title: "Client",
        field: "clientName",
        type: "string",
      },
      {
        title: "Country",
        field: "countryName",
        type: "string",
      },
      {
        title: "City",
        field: "cityName",
        type: "string",
      },
      {
        title: "Supervisor",
        field: "supervisor",
        type: "string",
      },
      {
        title: "Como/Non Como",
        field: "comonocomo",
        type: "string",
        headerStyle: {
          padding: "0px 16px",
        },
      },
      {
        title: "LOB",
        field: "lobCount",
        render: (rowData) => (
          <HtmlTooltip
            arrow
            placement="right"
            PopperProps={{
              disablePortal: true,
            }}
            disableFocusListener
            title={
              <React.Fragment>
                <ul
                  style={{
                    padding: "1em 0em 1em 1.5em",
                    margin: "0",
                    listStyleType: "circle",
                    lineHeight: "1.3",
                  }}
                >
                  {rowData?.lobs.map((l, i) => (
                    <li key={i} style={{ fontSize: "11px" }}>
                      {l.lobName}
                    </li>
                  ))}
                </ul>
              </React.Fragment>
            }
          >
            <div
              style={{
                backgroundColor: themeConfig.primary.purple,
                borderRadius: "99px",
                width: "25px",
                height: "25px",
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
                color: "white",
                fontSize: "1em",
              }}
            >
              {rowData?.lobCount}
            </div>
          </HtmlTooltip>
        ),
      },
      {
        title: "Disable",
        field: "statusId",
        cellStyle: {
          padding: "5px 35px",
        },
        render: (rowData) =>
          rowData && (
            <FormControlLabel
              control={
                <AntSwitch
                  size="small"
                  checked={rowData?.statusId}
                  onChange={() => toggleChecked(rowData)}
                />
              }
            />
          ),
      },
      {
        title: "Actions",
        field: "internal_action",
        render: (rowData) =>
          rowData && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Tooltip title="Edit">
                <IconButton
                  className={classes.active}
                  onClick={() => handleEditUser(rowData)}
                >
                  <EditTwoTone />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton
                  disabled={rowData.statusId}
                  className={classes.delete}
                  onClick={() => {
                    setOpenDeleteModal(rowData);
                  }}
                >
                  <DeleteTwoTone />
                </IconButton>
              </Tooltip>
              {/* 
              {rowData.totpStatus ? (
                <IconButton
                  className={classes.active}
                  onClick={() => setopenQrModal(rowData)}
                >
                  <Tooltip title="Enable QR Code">
                    <QrCode2Icon />
                  </Tooltip>
                </IconButton>
              ) : (
                <IconButton
                  className={classes.active}
                  disabled={true}
                  onClick={() => setopenQrModal(rowData)}
                >
                  <Tooltip title="Disable QR Code">
                    <QrCode2Icon />
                  </Tooltip>
                </IconButton>
              )} */}
            </div>
          ),
      },
    ]);
  }, [classes.active, classes.delete, user.roleId, UsersList, renderAgain]);

  let showSelectedMenu = () => {
    switch (selectedMenu[0]) {
      case "add":
        return (
          <>
            <CardsWrapper className="pt-3 pb-2">
              <div className="cards-wrapper">
                <Card
                  code="add"
                  title="Create User"
                  subtitle=""
                  icon="PersonAddIcon"
                  footerText=""
                  setFormTrigger={setFormTrigger}
                  coloricon="#FFFFFF"
                  colorBorder="#FFFFFF"
                />
                <Card
                  code="upload"
                  title="Bulk Upload"
                  subtitle=""
                  icon={
                    stateBulkUploadReducer.uploadingUsers
                      ? "CircularIndeterminate"
                      : "GroupAddIcon"
                  }
                  footerText=""
                  setFormTrigger={setFormTrigger}
                  coloricon="#FFFFFF"
                  colorBorder="#FFFFFF"
                />
              </div>
              <div className="right-section">
                <SearchComponent
                  handleSearch={handleSearch}
                  rSearch={rSearch}
                  setSearchText={setSearchText}
                />
                <ContentDownloadFile
                  className="mt-2"
                  // onClick={() => !loadingUsers && setShowAdvanceOption(true)}
                  onClick={() => !loadingUsers && showDownloadPage(true)}
                >
                  <ExcelIcon />
                  <TextDownloadFile style={{ marginRight: "2em" }}>
                    Download
                  </TextDownloadFile>
                </ContentDownloadFile>
              </div>
            </CardsWrapper>
            {loadingUsers ? (
              <ContentLoaderBulk>
                <PointersLine color={themeConfig.text.primary} />
              </ContentLoaderBulk>
            ) : null}
            {!loadingUsers && (
              <ContentTable>
                <MaterialTable
                  title="Users List"
                  style={{ boxShadow: "none", margin: "0 10px" }}
                  columns={columnUsers}
                  data={UsersList}
                  options={{
                    search: false,
                    paging: false,
                    toolbar: false,
                    maxBodyHeight: 450,
                    headerStyle: {
                      zIndex: 1,
                      fontWeight: "bold",
                    },
                    cellStyle: {
                      padding: "5px 10px",
                    },
                  }}
                ></MaterialTable>
                <div style={{ display: "flex", marginTop: "1rem" }}>
                  <Convention>
                    <div
                      style={{
                        background: "rgba(191, 191, 191, 1)",
                        height: "1em",
                        width: "1em",
                        borderRadius: "7px",
                      }}
                    ></div>
                    <p>Disable</p>
                    <div
                      style={{
                        background: "rgba(4, 180, 105, 1)",
                        height: "1em",
                        width: "1em",
                        borderRadius: "7px",
                      }}
                    ></div>
                    <p>Active</p>
                  </Convention>
                  <TablePagination
                    component="div"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      width: "100%",
                    }}
                    count={allPages}
                    page={page}
                    onPageChange={handleChangePageUsers}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={rowsPerPageOptions}
                    onRowsPerPageChange={handleChangeRowsPerPageUsers}
                  />
                </div>
              </ContentTable>
            )}
          </>
        );
      case "history":
        return (
          <>
            {loadingBulkHistory ||
              loadingBulkHistoryAfter ||
              loadingBulkHistoryBefore ? (
              <ContentLoaderBulk>
                <PointersLine color={themeConfig.text.primary}></PointersLine>
              </ContentLoaderBulk>
            ) : null}
            {(!loadingBulkHistory ||
              !loadingBulkHistoryAfter ||
              !loadingBulkHistoryBefore) &&
              Array.isArray(dataList) &&
              dataList.length > 0 && (
                <ContentTable
                  isUserHistoryTable={selectedMenu[0] === "history"}
                >
                  <MaterialTable
                    title="User history"
                    columns={[
                      {
                        title: "Date & Time",
                        field: "createDate",
                        type: "string",
                        render: (rowData) => {
                          return (
                            <>
                              {rowData.createDate
                                .split("T")[0]
                                .split("-")
                                .reverse()
                                .join("/")}
                            </>
                          );
                        },
                      },
                      {
                        title: "Users Created",
                        field: "totalCreated",
                        type: "string",
                        cellStyle: {
                          padding: "13px 53px",
                        },
                        render: (rowData) => {
                          return (
                            <>
                              {rowData?.totalCreated
                                ? rowData.totalCreated
                                : "-"}
                            </>
                          );
                        },
                      },
                      {
                        title: "Users Updated",
                        field: "totalUpdated",
                        type: "string",
                        cellStyle: {
                          padding: "13px 53px",
                        },
                        render: (rowData) => {
                          return (
                            <>
                              {rowData?.totalUpdated
                                ? rowData.totalUpdated
                                : "-"}
                            </>
                          );
                        },
                      },
                      {
                        title: "Users Deleted",
                        field: "totalDeleted",
                        type: "string",
                        cellStyle: {
                          padding: "13px 53px",
                        },
                        render: (rowData) => {
                          return (
                            <>
                              {rowData?.totalDeleted
                                ? rowData.totalDeleted
                                : "-"}
                            </>
                          );
                        },
                      },
                      {
                        title: "Users Failed",
                        field: "totalFailed",
                        type: "string",
                        cellStyle: {
                          padding: "13px 53px",
                        },
                        render: (rowData) => {
                          return (
                            <>
                              {rowData?.totalFailed ? rowData.totalFailed : "-"}
                            </>
                          );
                        },
                      },
                      {
                        title: "Time Elapsed",
                        field: "time",
                        type: "string",
                        render: (rowData) => {
                          return <>{rowData.elapsedTime}</>;
                        },
                      },
                      {
                        title: "Create By",
                        field: "createUser",
                        type: "string",
                      },
                      {
                        title: "Details",
                        field: "",
                        sorting: false,
                        render: (rowData) => {
                          if (rowData.uploadStatusId === 2) {
                            return (
                              <ActionDownLoadBulkError
                                onClick={() => {
                                  getBulkUploadResultLogTxtFile(rowData.id);
                                }}
                              >
                                <img src={download} alt="" />
                                <p>Download</p>
                              </ActionDownLoadBulkError>
                            );
                          } else if (rowData.uploadStatusId !== 2) {
                            return <DoneIcon style={{ color: themeConfig.status.success }} />;
                          } else {
                            return (
                              <LoadingFile>
                                <CircularIndeterminate size={"20"} />
                                <span>Loading...</span>
                              </LoadingFile>
                            );
                          }
                        },
                      },
                    ]}
                    data={dataList}
                    options={{
                      maxBodyHeight: 450,
                      headerStyle: {
                        zIndex: 1,
                        fontWeight: "bold",
                      },
                      cellStyle: {
                        padding: "13px 10px",
                      },
                      sorting: true,
                      paging: false,
                    }}
                  ></MaterialTable>
                  <TablePagination
                    component="div"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      padding: "2rem",
                    }}
                    count={allPages}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={rowsPerPageOptions}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </ContentTable>
              )}
          </>
        );
      default:
        break;
    }
  };

  return (
    <div>
      {formTrigger === "" && (
        <>
          <CardsWrapperUsers>{showSelectedMenu()}</CardsWrapperUsers>
        </>
      )}
      {(formTrigger === "add" ||
        formTrigger === "upload" ||
        formTrigger === "edit") && (
          <CreateUserContainer
            EditUser={EditUser}
            action={formTrigger}
            setFormTrigger={setFormTrigger}
            bulkUploadUsers={bulkUploadUsers}
          ></CreateUserContainer>
        )}
      {showDeleteModal()}
      {showQrModal()}
    </div>
  );
};

export default AdminUsersContainer;
